import React from "react";
import { useCurrentMultiplier } from "./Store/entities/multipliers/hooks";

type PricingUIProps = {
	quoteId: number;
	msrp: number;
};

const PricingUI = ({ msrp, quoteId }: PricingUIProps) => {
	const currentMultiplier = useCurrentMultiplier(quoteId);
	const { multiplier, currency_multiplier, currency } = currentMultiplier;
	const formattedNumber = (msrp * multiplier * currency_multiplier).toLocaleString('en-US', {
		style: 'currency',
		currency: currency || "USD"
	});
	return (
		<div>
			<span>
				{formattedNumber || "$0"}
			</span>
		</div>
	);
};
export default PricingUI;
